import {first, mergeMap} from 'rxjs/operators';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {AbstractControlReadonlyComponent} from './abstract-control-readonly';
import {ViewTabComponent} from '../viewtab.component';
import {ErrorService} from '../../../error/error.service';
import {Observable} from 'rxjs';
import {AddViewEvent} from '../../events/addviewevent';
import {ResourceService} from '../../resource.service';
import {EnvironmentConfigService} from '../../../core/services/environment-config.service';

@Component({
  selector: 'ctrl-requestsummary',
  template: `
    <request-summary-control
      [request]="request | async"
      (openDetail)="openDetail($event)"
    ></request-summary-control>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CtrlRequestSummary extends AbstractControlReadonlyComponent {
  constructor(
    parent: ViewTabComponent,
    changeDetector: ChangeDetectorRef,
    errorService: ErrorService,
    private resourceService: ResourceService,
    private envConfig: EnvironmentConfigService,
  ) {
    super(parent, null, changeDetector, errorService);
  }

  request: Observable<any> = null;

  protected initMain(): void {
    this.request = this.sourceObs.pipe(
      mergeMap((objectID: string) => this.resourceService.getResource(objectID)),
    );
    this.changeDetector.markForCheck();
  }

  openDetail(guid: Observable<string> | string | any) {
    if (guid == null) return;
    if (guid instanceof Observable) {
      guid.pipe(first()).subscribe(g => this._parent.onAddView.emit(new AddViewEvent('get', g)));
    } else if (typeof guid === 'string') {
      this._parent.onAddView.emit(new AddViewEvent('get', guid));
    } else if (typeof guid === 'object') {
      const objectIdAttr = this.envConfig.getAttributeName('ObjectID');
      const g = objectIdAttr ? guid[objectIdAttr] : null;
      if (g != null) {
        this._parent.onAddView.emit(new AddViewEvent('get', g));
      }
    }
  }
}
